/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ZSDTranslateService } from '../../../../../common/zsd-translate.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from '../../../../../shared/spinner/spinner.service';
import { BannerComponent } from '../../../../view/banner/banner.component';
import { ProposedSolutionService } from '../service/proposedsolution.service';
import { RequestProposedSolutionBasicInfo, RequestsProposedSolutionListEntity } from '../model/requestproposedsolutionbasicinfo';
declare var $: any;



@Component({
  selector: 'zsd-proposedsolutionlist',
  templateUrl: '../view/proposedsolutionlist.component.html',
  styleUrls: ['../view/proposedsolutionlist.component.scss']
})

export class ProposedSolutionListComponent implements OnInit {
  itemResultsCount = 0;
  itemsPerPage = 20;
  page = 0;
  isLoading = false;
  maxNoOfItems;
  isItemslist;
  scrollEndReached = false;
  isDesc = true;
  column;
  viewDetail = false;
  kbaId: number;
  order = 1;
  path;
  requestProposedSolutionBasicInfo = new Array<RequestProposedSolutionBasicInfo>();
  spinnerStart = true; // adding for showing spinner while loading instead of No request message


  @Output() openfilter = new EventEmitter<boolean>();

  itemDataFound = true;
  noRecords;
  requestId;
  columnTypeNumber;

  readonly ARTICLE_INDEX = 1000;
  readonly FAQ_INDEX = 2000;
  readonly SOLUTION_INDEX = 4000;

  constructor(public proposedsolutionservice: ProposedSolutionService,
    private route: ActivatedRoute, public zsdTranslate: ZSDTranslateService, public http: HttpClient,
    public spinnerService: SpinnerService) {
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      this.requestId = params['requestId'];
  });
    /* To refresh Global search dropdown */
  BannerComponent.refreshGlobalSearchDropdown.next(false);
  this.initializeItemsParameters();
  this.getProposedSolutionList();
  this.sort('relevance');
  }


  sort(property) {
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.column = property;
    this.order = this.order * (-1);
    if ( property === 'summary') {
      this.columnTypeNumber = false;
    } else {
      this.columnTypeNumber = true;
    }
  }

  getProposedSolutionList() {
      this.proposedsolutionservice
      .getProposedSolutionList(this.requestId)
        .subscribe(
          (requestsProposedSolutionListEntity: RequestsProposedSolutionListEntity) => {
            this.maxNoOfItems = requestsProposedSolutionListEntity.resultCount;
            if (this.maxNoOfItems > 0) {
              this.isItemslist = true;
              this.scrollEndReached = false;
            }
            this.requestProposedSolutionBasicInfo = this.requestProposedSolutionBasicInfo.concat(
              requestsProposedSolutionListEntity.results
            );
            this.page++;
            if (this.requestProposedSolutionBasicInfo.length >= this.maxNoOfItems) {
              // reached end of list
              this.scrollEndReached = true;
            }
            this.isLoading = false;
            this.spinnerStart = false;
          },
          err => {
            console.error(err.error);
            this.isLoading = false;
            this.spinnerStart = false;
          }
        );
    }

  trackByItems(index) {
    return index;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler() {
    new ProposedSolutionListComponent(
        this.proposedsolutionservice,
        this.route,  this.zsdTranslate,  this.http,
        this.spinnerService );
    window.scrollTo(0, 0);
  }
  initializeItemsParameters() {
    this.isLoading = false;
    this.page = 0;
    this.isItemslist = false;
    this.requestProposedSolutionBasicInfo = [];
  }

  showDetail(kbaId: number) {
    this.viewDetail = true;
    this.kbaId = kbaId;
    $('html, body').animate({
      scrollTop: $('#proposedsolution_detail').offset().top - 100}, 'slow');
  }
}
